import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2'; // Pop-up ke liye
import { API_BASE_URL } from "../config/api";

const emailPattern = /^[a-z0-9._%+-]+@gmail\.com$/i;
const gmailEmailMessage = "Please enter a valid Gmail address, for example name@gmail.com.";
const passwordLetterMessage = "Password must contain at least 6 letters.";
const countPasswordLetters = (value) => (String(value).match(/[A-Za-z]/g) || []).length;
const getPasswordError = (value) =>
  value && countPasswordLetters(value) < 6 ? passwordLetterMessage : "";

function ParentRegister() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [form, setForm] = useState({
    name: "",
    childName: "",
    email: "",
    password: "",
    mobile: "",
    schoolCode: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "email") {
      const email = value.trim().toLowerCase();
      setForm({ ...form, email });
      setEmailError(email && !emailPattern.test(email) ? gmailEmailMessage : "");
      return;
    }

    // ⭐ Mobile number logic: 10 digit se zyada allow nahi karega
    if (name === "password") {
      setForm({ ...form, password: value });
      setPasswordError(getPasswordError(value));
      return;
    }

    if (name === "mobile") {
      if (value.length <= 10) {
        setForm({ ...form, [name]: value });
      }
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");

    // ⭐ Validation: Check if mobile is exactly 10 digits
    if (form.mobile.length !== 10) {
      Swal.fire({
        icon: 'warning',
        title: 'Invalid Mobile',
        text: 'Mobile number must be exactly 10 digits.',
      });
      return;
    }

    if (!emailPattern.test(form.email)) {
      setEmailError(gmailEmailMessage);
      Swal.fire({
        icon: 'warning',
        title: 'Invalid Gmail',
        text: gmailEmailMessage,
      });
      return;
    }

    if (countPasswordLetters(form.password) < 6) {
      setPasswordError(passwordLetterMessage);
      Swal.fire({
        icon: 'warning',
        title: 'Weak Password',
        text: passwordLetterMessage,
      });
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(`${API_BASE_URL}/parent/register`, form);

      if (res.data.success) {
        await Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Registered Successfully ✅',
          timer: 2000,
          showConfirmButton: false
        });
        navigate("/parent/login");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Registration Failed");
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: err.response?.data?.message || "Registration Failed",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      style={{
        textAlign: "center",
        padding: "50px",
        display: "flex",
        justifyContent: "center",
        backgroundImage:
          "url(https://png.pngtree.com/background/20210709/original/pngtree-cartoon-education-training-cram-school-picture-image_917042.jpg)",
        backgroundSize: "cover",
      }}
    >
      <div className="container col-md-5">
        <form
          onSubmit={handleRegister}
          className="form-control p-4 shadow"
          style={{
            background: "rgba(255,255,255,0.2)",
            backdropFilter: "blur(10px)",
          }}
        >
          <h3 className="text-white mb-4">Parent Register</h3>
          
          <input type="text" name="name" placeholder="Parent Name" className="form-control mb-3 text-center  mx-auto w-75" onChange={handleChange} required />
          
          <input type="text" name="childName" placeholder="Child Name" className="form-control mb-3 text-center  mx-auto w-75" onChange={handleChange} required />

          {/* ⭐ Mobile Number with 10 digit limit */}
          <input 
            type="number" 
            name="mobile" 
            placeholder="10-Digit Mobile Number" 
            className="form-control w-75 text-center mx-auto mb-3" 
            onChange={handleChange} 
            value={form.mobile}
            required 
            onInput={(e) => {
              if (e.target.value.length > 10) e.target.value = e.target.value.slice(0, 10);
            }}
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            className={`form-control w-75 text-center mx-auto ${emailError ? "is-invalid mb-1" : "mb-3"}`}
            value={form.email}
            onChange={handleChange}
            onBlur={() => {
              const email = form.email.trim().toLowerCase();
              setForm({ ...form, email });
              setEmailError(email && !emailPattern.test(email) ? gmailEmailMessage : "");
            }}
            pattern="^[a-zA-Z0-9._%+-]+@gmail\.com$"
            required
          />
          {emailError && <div className="invalid-feedback d-block w-75 mx-auto mb-3 text-start">{emailError}</div>}
          
          <input
            type="password"
            name="password"
            placeholder="Password"
            className={`form-control w-75 text-center mx-auto ${passwordError ? "is-invalid mb-1" : "mb-3"}`}
            value={form.password}
            onChange={handleChange}
            onBlur={() =>
              setPasswordError(getPasswordError(form.password))
            }
            required
          />
          {passwordError && <div className="invalid-feedback d-block w-75 mx-auto mb-3 text-start">{passwordError}</div>}
          
          <input name="schoolCode" placeholder="School Code" className="form-control w-75 text-center mx-auto mb-3" onChange={handleChange} required />

          {error && <p className="text-danger text-center small">{error}</p>}

          <button type="submit" className="animated-btn btn border-1 w-75 border-light text-light" disabled={loading}>
             <span>Register</span>
          </button>

          <div className="text-light pt-3 small">
            Already have an account? <Link to="/parent/login" className="text-light fw-bold text-decoration-none ms-1">Login</Link>
          </div>
        </form>
      </div>
    </section>
  );
}

export default ParentRegister;
